// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Modal, Space, Button, Row, Col } from 'antd'
import { connect } from 'react-redux'
import { ModalProps } from 'antd/lib/modal'
import { IndividualUpload } from './IndividualUpload'
import { BatchUpload } from './BatchUpload'
import './index.less'
import { RootState } from 'store'

function mapState (rootState: RootState) {
  return {
    cities: rootState.city.cityList
  }
}

export type IInitialPanelProps = ModalProps & ReturnType<typeof mapState> & { onOk: void }

enum tab {
  Individual,
  Batch
}

const tabs = [
  {
    name: 'Individual',
    key: tab.Individual
  },
  {
    name: 'Batch',
    key: tab.Batch
  }
]

class InitialPanel extends React.Component<IInitialPanelProps> {
  state = {
    activeTab: tab.Individual
  }

  render () {
    const { activeTab } = this.state
    const { cities, onOk, ...modalProps } = this.props
    const title = (
      <Row align='middle' justify='space-between'>
        <Col
          style={{
            fontSize: 20,
            lineHeight: '28px'
          }}
        >
          Add a New Camera
        </Col>
        <Col>
          <Space className='tabs'>
            <Button.Group>
              {tabs.map(tab => (
                <Button
                  key={tab.key}
                  onClick={() => this.setState({ activeTab: tab.key })}
                  type={activeTab === tab.key ? 'primary' : 'default'}
                  shape='round'
                >
                  {tab.name}
                </Button>
              ))}
            </Button.Group>
          </Space>
        </Col>
      </Row>
    )
    return (
      <Modal
        {...modalProps}
        title={title}
        className='initial-modal'
        closable={false}
        width={716}
        style={{ borderRadius: 8 }}
        footer={null}
        destroyOnClose
      >
        <div className='initial-panel'>
          <div style={{ display: activeTab === tab.Individual ? 'block' : 'none' }}>
            <IndividualUpload cities={cities} onCancel={modalProps.onCancel} onSuccess={onOk} />
          </div>
          <div style={{ display: activeTab === tab.Batch ? 'block' : 'none' }}>
            <BatchUpload onSuccess={onOk} onCancel={modalProps.onCancel} />
          </div>
        </div>
      </Modal>
    )
  }
}

export default connect(mapState)(InitialPanel)
